(function (global) {
  'use strict';
  // Accessible per-unit color dropdown (button + listbox) for ClutchLoop package pills.
  // The builder keeps a hidden native <select> as its state bridge; this is the real control.
  // Options are read fresh on every open/refresh, so theme-editor reloads and availability
  // changes never show stale rows. The menu is portalled to <body> with fixed positioning.
  var uid = 0;

  function nextEnabled(options, from, step) {
    var n = options.length;
    for (var i = 1; i <= n; i++) {
      var k = ((from + step * i) % n + n) % n;
      if (options[k].available) return k;
    }
    return -1;
  }
  function edgeEnabled(options, last) {
    for (var i = 0; i < options.length; i++) {
      var k = last ? options.length - 1 - i : i;
      if (options[k].available) return k;
    }
    return -1;
  }

  // One registry per builder section: at most one open menu, single cleanup point.
  function createRegistry() {
    var items = [];
    return {
      add: function (d) { items.push(d); },
      closeOthers: function (d) { items.forEach(function (o) { if (o !== d) o.close(false); }); },
      destroy: function () { items.slice().forEach(function (d) { d.destroy(); }); items = []; }
    };
  }

  // opts: { doc, registry, label(name) -> aria label, getOptions() -> [{value,label,available,swatch()}],
  //         getValue() -> current value, onChoose(value), unavailableText }
  function attach(opts) {
    var doc = opts.doc || global.document;
    var id = 'clp-unit-list-' + (++uid);
    var button = doc.createElement('button');
    button.type = 'button';
    button.className = 'clp-unit__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', id);
    var list = null, options = [], active = -1, open = false, docHandlers = null;

    function rowId(i) { return id + '-opt-' + i; }
    function setActive(i) {
      active = i;
      if (!list) return;
      list.children.forEach ? list.children.forEach(paint) : Array.prototype.forEach.call(list.children, paint);
      if (i >= 0) { list.setAttribute('aria-activedescendant', rowId(i)); var row = list.children[i]; if (row && row.scrollIntoView) row.scrollIntoView({ block: 'nearest' }); }
      else list.removeAttribute('aria-activedescendant');
    }
    function paint(row, i) { row.classList.toggle('is-active', i === active); }
    function build() {
      options = opts.getOptions() || [];
      var current = String(opts.getValue() || '').toLowerCase();
      if (!list) {
        list = doc.createElement('ul');
        list.id = id;
        list.className = 'clp-unit-menu';
        list.setAttribute('role', 'listbox');
        list.tabIndex = -1;
        list.addEventListener('keydown', onKey);
        list.addEventListener('click', function (event) {
          var t = event && event.target;
          while (t && t !== list && t.dataset && t.dataset.clpIndex == null) t = t.parentNode;
          if (t && t.dataset && t.dataset.clpIndex != null) choose(Number(t.dataset.clpIndex));
        });
      }
      list.setAttribute('aria-label', opts.label(opts.getValue()));
      var rows = options.map(function (o, i) {
        var row = doc.createElement('li');
        var selected = String(o.value).toLowerCase() === current;
        row.id = rowId(i);
        row.className = 'clp-unit-menu__option' + (selected ? ' is-selected' : '') + (o.available ? '' : ' is-disabled');
        row.setAttribute('role', 'option');
        row.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (!o.available) row.setAttribute('aria-disabled', 'true');
        row.dataset.clpIndex = String(i);
        row.title = o.available ? o.label : o.label + ' (' + (opts.unavailableText || 'Unavailable') + ')';
        var sw = o.swatch ? o.swatch() : doc.createElement('span');
        sw.className = (sw.className ? sw.className + ' ' : '') + 'clp-unit-menu__swatch';
        var name = doc.createElement('span');
        name.className = 'clp-unit-menu__name';
        name.textContent = o.label;
        row.appendChild(sw); row.appendChild(name);
        if (!o.available) { var note = doc.createElement('span'); note.className = 'clp-unit-menu__note'; note.textContent = opts.unavailableText || 'Unavailable'; row.appendChild(note); }
        var tick = doc.createElement('span');
        tick.className = 'clp-unit-menu__check';
        tick.setAttribute('aria-hidden', 'true');
        row.appendChild(tick);
        return row;
      });
      list.replaceChildren.apply(list, rows);
      var sel = options.findIndex(function (o) { return String(o.value).toLowerCase() === current; });
      setActive(sel >= 0 && options[sel].available ? sel : edgeEnabled(options, false));
    }
    function position() {
      if (!list || !button.getBoundingClientRect) return;
      var r = button.getBoundingClientRect();
      var vw = global.innerWidth || 360, vh = global.innerHeight || 640, gap = 6, margin = 8;
      var below = vh - r.bottom - gap - margin, above = r.top - gap - margin;
      var natural = Math.min(320, (list.scrollHeight || 320));
      var up = below < Math.min(natural, 200) && above > below;
      var width = Math.min(Math.max(r.width, 210), vw - margin * 2);
      list.style.position = 'fixed';
      list.style.width = width + 'px';
      list.style.left = Math.max(margin, Math.min(r.left, vw - width - margin)) + 'px';
      list.style.maxHeight = Math.max(120, Math.min(320, up ? above : below)) + 'px';
      list.style.top = up ? 'auto' : (r.bottom + gap) + 'px';
      list.style.bottom = up ? (vh - r.top + gap) + 'px' : 'auto';
      list.classList.toggle('is-above', up);
    }
    // The portalled menu sits outside the section, so copy the pill's computed typography and
    // color, and the group/section surface tokens, at open time (merchant controls carry over).
    function inherit() {
      var src = opts.styleSource, gcs = global.getComputedStyle;
      if (!src || !gcs || !list) return;
      var cs = gcs(src);
      if (!cs) return;
      ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'color'].forEach(function (k) { if (cs[k]) list.style[k] = cs[k]; });
      function token(names) {
        for (var i = 0; i < names.length; i++) { var v = cs.getPropertyValue ? String(cs.getPropertyValue(names[i]) || '').trim() : ''; if (v) return v; }
        return '';
      }
      function setVar(name, value) { if (!value) return; if (list.style.setProperty) list.style.setProperty(name, value); else list.style[name] = value; }
      setVar('--clp-menu-bg', token(['--clp-pill-bg', '--clpg-bg', '--clp-surface', '--clp-accent']));
      setVar('--clp-menu-swatch', token(['--clp-pill-swatch']));
      setVar('--clp-menu-selected', token(['--clpg-selected-bg', '--clp-card-selected', '--clp-accent']));
    }
    function show() {
      if (open) return;
      opts.registry && opts.registry.closeOthers(api);
      build();
      inherit();
      (doc.body || doc).appendChild(list);
      open = true;
      button.setAttribute('aria-expanded', 'true');
      position();
      docHandlers = {
        down: function (event) { var t = event && event.target; if (!contains(list, t) && !contains(button, t)) close(false); },
        move: function () { position(); }
      };
      doc.addEventListener('pointerdown', docHandlers.down, true);
      if (global.addEventListener) { global.addEventListener('resize', docHandlers.move); global.addEventListener('scroll', docHandlers.move, true); }
      if (list.focus) list.focus({ preventScroll: true });
    }
    function contains(root, node) { while (node) { if (node === root) return true; node = node.parentNode; } return false; }
    function close(restore) {
      if (!open) return;
      open = false;
      button.setAttribute('aria-expanded', 'false');
      if (list && list.parentNode) list.parentNode.removeChild(list);
      if (docHandlers) {
        doc.removeEventListener('pointerdown', docHandlers.down, true);
        if (global.removeEventListener) { global.removeEventListener('resize', docHandlers.move); global.removeEventListener('scroll', docHandlers.move, true); }
        docHandlers = null;
      }
      if (restore && button.focus) button.focus();
    }
    function choose(i) {
      var o = options[i];
      if (!o || !o.available) return; // disabled rows can never be chosen
      close(true);
      opts.onChoose(o.value);
    }
    function onKey(event) {
      var key = event.key, handled = true;
      if (key === 'ArrowDown') setActive(nextEnabled(options, active < 0 ? -1 : active, 1));
      else if (key === 'ArrowUp') setActive(nextEnabled(options, active < 0 ? 0 : active, -1));
      else if (key === 'Home') setActive(edgeEnabled(options, false));
      else if (key === 'End') setActive(edgeEnabled(options, true));
      else if (key === 'Enter' || key === ' ') choose(active);
      else if (key === 'Escape') close(true);
      else if (key === 'Tab') { close(false); handled = false; }
      else handled = false;
      if (handled && event.preventDefault) event.preventDefault();
      if (event.stopPropagation) event.stopPropagation();
    }
    function onButtonClick(event) {
      if (event && event.stopPropagation) event.stopPropagation(); // never toggles the card twice
      if (event && event.preventDefault) event.preventDefault();
      if (open) close(true); else { opts.onOpen && opts.onOpen(); show(); }
    }
    function onButtonKey(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (event.preventDefault) event.preventDefault();
        if (!open) { opts.onOpen && opts.onOpen(); show(); }
        if (event.key === 'ArrowUp') setActive(edgeEnabled(options, true));
      }
    }
    button.addEventListener('click', onButtonClick);
    button.addEventListener('keydown', onButtonKey);

    var api = {
      button: button,
      isOpen: function () { return open; },
      list: function () { return list; },
      open: show,
      close: close,
      keydown: onKey,
      choose: choose,
      update: function () { button.setAttribute('aria-label', opts.label(opts.getValue())); },
      refresh: function () { if (open) { build(); position(); } },
      destroy: function () {
        close(false);
        button.removeEventListener('click', onButtonClick);
        button.removeEventListener('keydown', onButtonKey);
        if (list) list.removeEventListener('keydown', onKey);
        list = null;
      }
    };
    api.update();
    opts.registry && opts.registry.add(api);
    return api;
  }

  var exported = { attach: attach, createRegistry: createRegistry, nextEnabled: nextEnabled, edgeEnabled: edgeEnabled };
  global.ClutchLoopUnitDropdown = exported;
  if (typeof module !== 'undefined' && module.exports) module.exports = exported;
})(typeof window !== 'undefined' ? window : globalThis);
